import { render } from "./DebtAccounts.vue?vue&type=template&id=e73238ce&scoped=true"
import script from "./DebtAccounts.vue?vue&type=script&lang=js"
export * from "./DebtAccounts.vue?vue&type=script&lang=js"

import "./DebtAccounts.vue?vue&type=style&index=0&id=e73238ce&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e73238ce"]])

export default __exports__